/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/jquery/jquery.velir.js"/>
/// <reference path="BaseSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.LocationSelectorView = ns.BaseSelectorView.extend({
    name: "Location Selector",
    el: "#location-selector",
    templateSelector: "#location-selector-template",
    propertyName: "locationIds",

    initialize: function() {
      _.bindAll(this);

      $(window).on("resize", this.repositionMultiselect);
    },

    events: {
      change: "onChangeUpdateModel"
    },

    onChangeUpdateModel: function() {
      var props, optionIds;

      props = {};

      optionIds = $("select", this.$el).val();

      props[this.propertyName] = optionIds || [];

      this.model.set(props);

      // Tracks if user changes location type on the "Explore Data" page
      var $dropdown = $("select", this.$el);
      var dropdownValues = $dropdown.val();
      var communityNames = [];
      if (dropdownValues && dropdownValues.length) {
        for (var i in dropdownValues) {
          var selector = "option[value=" + dropdownValues[i] + "]";
          communityNames.push($(selector, $dropdown).text());
        }
        communityNames = communityNames.sort();
      }
      else {
        communityNames = "Uncheck All";
      }
      dataLayer.push({
        event: "Location Type Dropdown Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Location Type Dropdown|" + communityNames,
        eventLabel: window.location.pathname
      });
    },

    initializeModel: function() {
      // Update the model with the first item in the dropdown
      this.model.set(
        this.propertyName,
        [$("select option:first", this.$el).val()],
        { silent: true }
      );
    },

    /**
     * Repositions the multiselect, as the plugin (unwisely) positions the dropdown out of the select
     * element's scope.
     */
    repositionMultiselect: function() {
      this.$(".location-type select")
        // Make sure multiselect is initialized.
        .multiselect(this.defaultMultiSelectOptions)
        .multiselect("position");
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      var $selectedOptions;

      $selectedOptions = $("select option:selected", this.$el);

      if (!$selectedOptions.length) {
        return "No Locations Selected";
      }

      if ($selectedOptions.length === 1) {
        return $selectedOptions.text();
      }
      return $selectedOptions.length + " Locations";
    },

    render: function(selectorInfo) {
      // Call the base implementation
      ns.LocationSelectorView.__super__.render.call(this, selectorInfo);

      this.$(".location-type select").multiselect(
        this.defaultMultiSelectOptions
      );
    },

    updateDOM: function() {
      var modelProp;

      modelProp = this.model.get(this.propertyName);

      // Set the option corresponding to the value on the model
      $("select", this.$el)
        .val(modelProp)
        .updateSelect();
    }
  });
})(jQuery, _);
